import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { superstyled } from '@zenbusiness/zui/styles';

export const WarningIcon = superstyled({
  name: 'BankingTransitionBannerWarningIcon',
  slot: 'Root',
  tag: WarningRoundedIcon,
  styles: ({ theme }) => ({
    color: theme.palette.text.primary,
    fontSize: 32,
  }),
});
